import React from 'react';
import { Button, Card, CardActions, CardContent } from '@mui/material';
import { useSelector } from 'react-redux';
import * as authService from '../services/auth';

const PushInstallButtonDesktopNotification = ({ onAccept, onDismiss }) => {
  const user = authService.getCurrentlyLoggedInOrImpersonatingUser();
  const isDrawerOpen = useSelector((state) => state.ui.persisted.isDrawerOpen);

  const paddingLeftValueAboveSmBreakpoint = (() => {
    if (user && !authService.shouldHideMainDrawer(user)) {
      return isDrawerOpen ? '235px' : '70px';
    }

    return '16px';
  })();

  return (
    <Card
      sx={{
        backgroundColor: '#e1ebfd',
        width: '100%',
        paddingLeft: {
          xs: 0,
          sm: paddingLeftValueAboveSmBreakpoint,
        },
      }}
    >
      <CardContent style={{ paddingBottom: 0 }} data-testid="close-rescue-reminder-card">
        <div style={{ fontSize: '16px', fontWeight: 'bold' }}>Push notifications</div>
        <div style={{ fontSize: '13px', color: 'rgba(0, 0, 0, 0.54)' }}>Do you want to enable push notifications?</div>
      </CardContent>

      <CardActions>
        <Button size="small" color="primary" variant="contained" onClick={onAccept}>
          Yes
        </Button>

        <Button size="small" color="primary" onClick={onDismiss}>
          Not now
        </Button>
      </CardActions>
    </Card>
  );
};

export default PushInstallButtonDesktopNotification;
